export default __webpack_public_path__ + "static/media/first-watch-me.0350e25d.mp3";